// src/components/Common/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0f172a] text-white pt-12 mt-10 w-full border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 pb-10 border-b border-white/10">
          
          {/* Brand Section */}
          <div className="lg:col-span-2 pr-0 lg:pr-8">
            <Link to="/" className="flex items-center gap-2.5 mb-6 inline-block">
              <div className="flex items-center">
                <span className="text-[#E32726] text-3xl font-black italic tracking-widest drop-shadow-sm" style={{ textShadow: '-1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff, 1.5px 1.5px 0 #fff' }}>
                  SV MART
                </span>
              </div>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-sm font-medium">
              Your one-stop shop for all your daily needs. We deliver quality products at affordable prices directly to your doorstep.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/70 hover:bg-[#E32726] hover:text-white hover:border-[#E32726] transition-all shadow-sm">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/70 hover:bg-[#E32726] hover:text-white hover:border-[#E32726] transition-all shadow-sm">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/70 hover:bg-[#E32726] hover:text-white hover:border-[#E32726] transition-all shadow-sm">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/70 hover:bg-[#E32726] hover:text-white hover:border-[#E32726] transition-all shadow-sm">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-bold text-white mb-5 tracking-wider uppercase">Quick Links</h4>
            <ul className="space-y-3.5">
              <li><Link to="/about-us" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">About Us</Link></li>
              <li><Link to="/contact-us" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">Contact Us</Link></li>
              <li><Link to="/privacy-policy" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-base font-bold text-white mb-5 tracking-wider uppercase">Support</h4>
            <ul className="space-y-3.5">
              <li><Link to="/return-policy" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">Return Policy</Link></li>
              <li><Link to="/shipping-info" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">Shipping Info</Link></li>
              <li><Link to="/payment-options" className="text-sm font-medium text-white/60 hover:text-[#E32726] hover:translate-x-1 inline-block transition-all">Payment Options</Link></li>
            </ul>
          </div>

          {/* Download App */}
          <div>
            <h4 className="text-base font-bold text-white mb-5 tracking-wider uppercase">Download App</h4>
            <div className="flex flex-col gap-3 mb-8">
              <button className="flex items-center gap-3 bg-white/5 border border-white/10 text-white px-4 py-2.5 rounded-xl hover:bg-white/10 hover:border-white/20 transition-all w-full sm:w-auto md:w-full group">
                <i className="fab fa-google-play text-xl text-gray-400 group-hover:text-white transition-colors"></i>
                <div className="text-left">
                  <div className="text-[9px] font-bold uppercase tracking-widest text-white/50">Get it on</div>
                  <div className="text-sm font-bold leading-tight">Google Play</div>
                </div>
              </button>
              <button className="flex items-center gap-3 bg-white/5 border border-white/10 text-white px-4 py-2.5 rounded-xl hover:bg-white/10 hover:border-white/20 transition-all w-full sm:w-auto md:w-full group">
                <i className="fab fa-apple text-xl text-gray-400 group-hover:text-white transition-colors"></i>
                <div className="text-left">
                  <div className="text-[9px] font-bold uppercase tracking-widest text-white/50">Download on the</div>
                  <div className="text-sm font-bold leading-tight">App Store</div>
                </div>
              </button>
            </div>
          </div>

        </div>

        {/* Bottom Footer */}
        <div className="py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50 font-medium">
            &copy; {new Date().getFullYear()} SV Mart. All rights reserved.
          </p>
          <p className="text-sm text-white/50 font-medium flex items-center gap-1.5">
            Made with <i className="fas fa-heart text-[#E32726]"></i> in India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;